
var Labels = {
    filters: {
        function: "Product function",
        ecolabel: "Ecolabel",
        rci: "RCI %",
        ewg: "EWG Score",
        showResults: "Show results",
        clear: "Clear filters",
        selectFunction: "Please select a function",
        rciExplanation: "Renewable Carbon Index",
        ewgExplanation: "The Environmental Working Group"
    },
    more: "More",
    changeFilters: "Change filters",
    noItems: "No products match your current filters",
    init() {
        var oThis = this;
        var labels = document.querySelectorAll(".ecolabel-params > .labels > input[type='hidden']");
        if (labels && labels.length > 0) {
            for (var i = 0; i < labels.length; i++) {
                var item = labels[i];
                var lid = item.id.split('-');
                if (item.value && lid && lid.length === 2) {
                    oThis[lid[1]] = item.value;
                } else if (item.value && lid && lid.length === 3) {
                    oThis.filters[lid[2]] = item.value;
                }
            }
        }
    }
};

export default Labels;